module.exports = __webpack_public_path__ + "static/media/hero-3-square.826aba96.jpg";